<script>
    import { onMount } from 'svelte'
    import { fly } from 'svelte/transition'
    import { homeURL } from '../../store.js'
    import { flyModified } from '../../js/transitions.js'
    import { handleHashChange } from '../../js/hash-scroll.js'
    import { compareDate } from '../../js/util.js'
    import NewsUpdate from '../content-types/NewsUpdate.svelte'
    import LabAtWork from '../content-types/LabAtWork.svelte'
    import TeeShirts from '../content-types/TeeShirts.svelte'
    export let page

    onMount(handleHashChange) // init scroll position on mount
</script>

<div
    id="newsContent"
    style="--pageColor: {page.circuit_color};"
    out:flyModified={{ y: 10, duration: 400, position: 'absolute' }}
>
    <h2 class="sectionTitle" id="labupdates">
        {page.UpdatesTitle}
    </h2>
    {#each page.updates.sort(compareDate) as update}
        <div
            in:fly={{ y: -20, duration: 1000 }}
            out:fly={{ y: 10, duration: 400 }}
        >
            <NewsUpdate {update} color={page.circuit_color} />
        </div>
    {/each}
    <div class="sectionLink">
        <a href="{homeURL}/updates">
            See All Past News Items
        </a>
    </div>

    <h2 class="sectionTitle" id="alabatwork">
        {page.LabAtWorkTitle}
    </h2>
    {#each page.lab_at_work.sort(compareDate) as item}
        <div
            in:fly={{ y: -20, duration: 1000 }}
            out:fly={{ y: 10, duration: 400 }}
        >
            <LabAtWork {item} color={page.circuit_color} />
        </div>
    {/each}
    <div class="sectionLink">
        <a href="{homeURL}/lablife">
            See All Past Photos of the Lab
        </a>
    </div>

    <h2 class="sectionTitle" id="tshirts">
        T-Shirts
    </h2>
    <p class="teeShirtText">
        {page.TeeShirtText}
    </p>
    <TeeShirts teeShirts={page.teeShirts} color={page.circuit_color} />
</div>

<style lang="scss">
    @import "../../styles/vars";

    .sectionTitle:first-of-type {
        margin-top: 0;
    }

    #newsContent {
        box-sizing: border-box;
        position: relative;
        width: 50vw;
        margin: 0 25vw;
        top: 0;
        padding: 50px 0;
    }

    .sectionLink {
        display: inline-block;
        user-select: none;
        font-family: "Work Sans";
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: .05rem;
        line-height: 1.8rem;
        font-size: 0.9rem;
        border-bottom: solid 2px var(--pageColor);

        a {
            color: black;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .teeShirtText {
        font-family: "Ysabeau";
        margin-bottom: 2rem;
        font-size: 1.2rem;
    }

    @include respond-to(phone) {
        #newsContent {
            padding-top: 0;
            width: 96vw;
            margin: 0 2vw 50px;
        }

        .sectionLink {
            margin-bottom: 2rem;
        }
    }
</style>
